import api, { Notifiable } from '../api';
import { CrfDistribuicao } from './crfContratoPcs';

const controller = 'CrfContratadoSemVinculoCc';

export interface CrfPedidoSemVinculoFormulario {
    numeroOrdemInvestimentoFormulario?: string;
    codigoCentroCustoFormulario?: string;
    nomeCentroCustoFormulario?: string;
    statusModuloEconomicoFormulario?: string[];

    acronimoAgrupadorFormulario?: string;
    codigoAgrupadorFormulario?: string;
    codigoContaContabilFormulario?: string;

    numeroRequisicaoCompraFormulario?: string
    numeroItemRequisicaoCompraFormulario?: string;
    dataRequisicaoCompraFormulario?: string;
    statusRequisicaoCompraFormulario?: string[];

    numeroOrdemCompraFormulario?: string;
    dataEmissaoOrdemCompraFormulario?: string;

    numeroPedidoCompraFormulario?: string;
    tipoPedidoCompraFormulario?: string;
    nomeFornecedorPedidoCompraFormulario?: string;
    dataPedidoCompraFormulario?: string;

    numeroContratoPcsFormulario?: string;
}


export interface CrfPedidoSemVinculoResult extends Notifiable {
    row: number;
    id: string;
    crfContaContabilCcRcSeqId: string;
    requisicaoCompraSeqId: string;
    agrupador: string;
    contaContabilCodigo: string;
    contaContabilNome: string;
    ocData: string;
    ocNumero: string;
    ocNumeroFormatado: string;
    pacoteCodigo: string;
    pacoteNome: string;
    pacoteNumero: string;
    projetoNome: string;
    projetoNumero: string;
    projetoNumeroInt: string;
    rcNarrativa: string;
    rcNumero: string;
    rcNumeroFormatado: string;
    rcSeq: string;
    rcSeqFormatado: string;
    rcStatus: string;
}

export const getFilterPedidoSemVinculo = (values: CrfPedidoSemVinculoFormulario) => {
    var query = "";

    query += values.numeroOrdemInvestimentoFormulario ? "numeroOrdemInvestimento=" + values.numeroOrdemInvestimentoFormulario : "";

    // query += values.numeroCentroCustoFormulario ? "numeroCentroCusto=" + values.numeroCentroCustoFormulario : "";
    // query += values.codigoCentroCustoFormulario ? "&codigoCentroCusto=" + values.codigoCentroCustoFormulario : "";
    // query += values.nomeCentroCustoFormulario ? "&nomeCentroCusto=" + values.nomeCentroCustoFormulario : "";
    // query += values.statusModuloEconomicoFormulario ? "&statusModuloEconomico=" + values.statusModuloEconomicoFormulario.join('&statusModuloEconomico=') : "";

    // query += values.acronimoAgrupadorFormulario ? "&acronimoAgrupador=" + values.acronimoAgrupadorFormulario : "";
    // query += values.codigoAgrupadorFormulario ? "&codigoAgrupador=" + values.codigoAgrupadorFormulario : "";
    query += values.codigoContaContabilFormulario ? "&codigoContaContabil=" + values.codigoContaContabilFormulario : "";

    query += values.numeroRequisicaoCompraFormulario ? "&numeroRequisicaoCompra=" + values.numeroRequisicaoCompraFormulario : "";
    query += values.numeroItemRequisicaoCompraFormulario ? "&numeroItemRequisicaoCompra=" + values.numeroItemRequisicaoCompraFormulario : "";
    query += values.statusRequisicaoCompraFormulario ? "&statusRequisicaoCompra=" + values.statusRequisicaoCompraFormulario.join('&statusRequisicaoCompra=') : "";
    // query += values.dataRequisicaoCompraFormulario ? "&dataRequisicaoCompra=" + values.dataRequisicaoCompraFormulario : "";

    query += values.numeroOrdemCompraFormulario ? "&numeroOrdemCompra=" + values.numeroOrdemCompraFormulario : "";
    query += values.dataEmissaoOrdemCompraFormulario ? "&dataEmissaoOrdemCompra=" + values.dataEmissaoOrdemCompraFormulario : "";

    query += values.numeroPedidoCompraFormulario ? "&numeroPedidoCompra=" + values.numeroPedidoCompraFormulario : "";
    query += values.tipoPedidoCompraFormulario ? "&tipoPedidoCompra=" + values.tipoPedidoCompraFormulario : "";
    query += values.nomeFornecedorPedidoCompraFormulario ? "&nomeFornecedorPedidoCompra=" + values.nomeFornecedorPedidoCompraFormulario : "";
    // query += values.dataPedidoCompraFormulario ? "&dataPedidoCompra=" + values.dataPedidoCompraFormulario : "";

    query += values.numeroContratoPcsFormulario ? "&numeroContratoPcs=" + values.numeroContratoPcsFormulario : "";

    query = query.replace(/^&/, '');
    return api.get<CrfPedidoSemVinculoResult[]>(`${controller}/semVinculo?${query}`);
};

export const getAllCrfContratoAnoSemVinculo = (requisicaoCompraSeqId: string) =>
    api.get<CrfDistribuicao>(`${controller}/getAllContratoAnoSemVinculo/${requisicaoCompraSeqId}`);

export const adicionarLinhaItemCrfPedidoSemVinculoRateavel = (ordemInvestimentoId: any, requisicaoCompraSeqId: string) => {
    const form = new FormData();
    form.append('ordemInvestimentoId', ordemInvestimentoId);
    form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
    return api.post<any>(`${controller}/adicionarLinhaItemSemVinculoRateavel`, form);
};

export const atualizarValorCrfContratadoAnoSemVinculoCc = (
    moduloEconomicoContratadoId: any,
    ordemInvestimentoId: any,
    requisicaoCompraSeqId: any,
    valorAlterado: string,
    ano: string,
) => {
    const form = new FormData();
    form.append('moduloEconomicoContratadoId', moduloEconomicoContratadoId);
    form.append('ordemInvestimentoId', ordemInvestimentoId);
    form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
    form.append('valor', valorAlterado);
    form.append('ano', ano);
    form.append('anoTexto', ano);

    return api.post<any>(`${controller}/atualizarValorContratadoAnoSemVinculo`, form);
};

export const concluirRateioCtPcmCrfPedidoSemVinculo = (crfRequisicaoCompraSeqId: string) => {
    const form = new FormData();
    form.append('crfRequisicaoCompraSeqId', crfRequisicaoCompraSeqId);
    return api.post<any>(`${controller}/ConcluirRateioCtPedidoSemVinculo`, form);
};

export const obterNarativaPorCrfRequisicaoCompraSeqId = (id: any) =>
    api.get<string>(`${controller}/obterNarativaPorCrfRequisicaoCompraSeqId/${id}`);
